var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheckGreen = function SvgIconCheckGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon-check-green_svg__a",
    d: "m11.312 16.878 8.385-7.732c.09-.087.09-.23.003-.317l-1.711-1.706a.22.22 0 0 0-.312 0l-6.363 5.956a.223.223 0 0 1-.309.004L7.731 10.28a.22.22 0 0 0-.31.003l-1.71 1.712a.223.223 0 0 0 .006.318l5.29 4.567a.22.22 0 0 0 .305-.003"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon-check-green_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon-check-green_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon-check-green_svg__a",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#10D365",
    mask: "url(#icon-check-green_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgIconCheckGreen as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiPjxkZWZzPjxwYXRoIGlkPSJhIiBkPSJNMTEuMzEyIDE2Ljg3OGw4LjM4NS03LjczMmMuMDktLjA4Ny4wOS0uMjMuMDAzLS4zMTdsLTEuNzExLTEuNzA2YS4yMi4yMiAwIDAwLS4zMTIgMGwtNi4zNjMgNS45NTZhLjIyMy4yMjMgMCAwMS0uMzA5LjAwNEw3LjczMSAxMC4yOGEuMjIyLjIyMiAwIDAwLS4zMS4wMDNsLTEuNzEgMS43MTJhLjIyMy4yMjMgMCAwMC4wMDYuMzE4bDUuMjkgNC41NjdhLjIyLjIyIDAgMDAuMzA1LS4wMDMiLz48L2RlZnM+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48bWFzayBpZD0iYiIgZmlsbD0iI2ZmZiI+PHVzZSB4bGluazpocmVmPSIjYSIvPjwvbWFzaz48dXNlIGZpbGw9IiNGRkYiIHhsaW5rOmhyZWY9IiNhIi8+PGcgZmlsbD0iIzEwRDM2NSIgbWFzaz0idXJsKCNiKSI+PHBhdGggZD0iTTAgMGgyNHYyNEgweiIvPjwvZz48L2c+PC9zdmc+";